import type {
  BlockingRule,
  BlockingRuleWire,
} from 'BlockList/types/blockingRule';

/**
 * Single source of truth for snake_case wire → camelCase domain transform.
 * Used by GetBlockingRules and PatchBlockingRule.
 */
export const transformBlockingRule = (raw: BlockingRuleWire): BlockingRule => ({
  id: raw.id,
  name: raw.name,
  description: raw.description ?? null,
  attributeTypes: raw.criteria.attribute_types,
  matchStrategy: raw.criteria.match_strategy,
  enabled: raw.enabled,
  createdAt: raw.created_at,
  updatedAt: raw.updated_at,
  deletedAt: raw.deleted_at ?? null,
});
